export default "__VITE_ASSET__7cd6cf36__"